import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { isValidErrorResponse } from 'api/api.config';
import { isValidationError } from 'api/validation/validation.helpers';

export const transformSignUpErrorResponse = (
  errorResponse: FetchBaseQueryError,
) => {
  const errorResponseData = errorResponse.data;
  const is422Error = errorResponse.status === 422;

  if (!is422Error || !isValidErrorResponse(errorResponseData)) {
    return errorResponse;
  }

  const apiErrorMessage = errorResponseData.error.errorInfos?.generic?.[0];

  if (apiErrorMessage && isValidationError(apiErrorMessage))
    return {
      errorMessage: 'verifyService.' + apiErrorMessage,
    };

  return errorResponse;
};
